import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./context/LanguageContext";

// Layout components
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";

// Pages
import HomePage from "./pages/HomePage";
import PresentationPage from "./pages/PresentationPage";
import MenuPage from "./pages/MenuPage";
import HistoryPage from "./pages/HistoryPage";
import EventsPage from "./pages/EventsPage";
import ReservationPage from "./pages/ReservationPage";
import ContactPage from "./pages/ContactPage";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/presentation" element={<PresentationPage />} />
              <Route path="/menu" element={<MenuPage />} />
              <Route path="/histoire" element={<HistoryPage />} />
              <Route path="/evenements" element={<EventsPage />} />
              <Route path="/reservation" element={<ReservationPage />} />
              <Route path="/contact" element={<ContactPage />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
